import React, { useEffect, useState } from 'react';
import useFetch from '../CustomHooks/useFetch';
import '../Styles/MailVerification.scss';
import Logo from '../Images/ht_logo_final.png';



export default function MailVerification() {
    const [response, fetchData] = useFetch();
    const [status, setStatus] = useState('Verifying')
    const [guiLanguage, setGuiLanguage] = useState('en');


    useEffect(
        () => {
            if (window.location.href.indexOf('lang=tr') > 0) {
                setGuiLanguage('tr');
            }
        }, []
    )

    useEffect(
        () => {
            let code = window.location.pathname.replace('/mailVerification/', '');
            console.log(code);

            fetchData(
                {
                    url: '/api/registration/confirmemail/' + code,
                    method: 'PUT',
                }
            )

        }, []
    )

    useEffect(
        () => {
            async function f() {
                if (response != null) {
                    if (response.length != 0) {
                        if (response) {
                            setStatus('Verified');
                        } else {
                            setStatus('Rejected');
                        }
                    }
                }
            }
            f();
        }, [response]
    )

    return (
        <div>
            <div style={{ display: 'flex', marginTop: '100px' }}><img style={{ width: '150px', margin: 'auto' }} src={Logo}></img></div>
            {
                status == "Verifying" ?
                    <div className="mail-verification">
                        {
                            guiLanguage == 'tr' ?
                                <span>
                                    Onaylama sürüyor. Lütfen bekleyiniz.
                    </span>
                                :
                                <span>
                                    Verification in progress. Please stand by.
                    </span>

                        }
                    </div>
                    : null
            }


            {
                status == "Rejected" && guiLanguage == 'tr' ?
                    <div className="mail-verification">
                        E-postanız onaylanamadı! E-posta adresinizi daha önceden onaylamış olabilirsiniz. Giriş yapmayı deneyin: <LoginLink /> .
                        <br></br>
                        Eğer işe yaramaz ise destek departmanı ile iletişime geçin <a href="https://happytable.app/support.html"> </a>
                    </div>
                    :
                    null
            }
            {
                status == "Rejected" && guiLanguage != 'tr' ?
                    <div className="mail-verification">
                        Verification rejected! You may have verified your email before so please try to <LoginLink /> .
                    <br></br>
                    If it does not work please contact <a href="https://happytable.app/support.html"> support</a>
                    </div>
                    :
                    null
            }
            
            {
                status == "Verified" && guiLanguage == 'tr' ?
                    <div className="mail-verification">
                    
                        E-postanız onaylandı. Giriş yapabilirsiniz <LoginLink lang='tr' />! 
                        
                    </div>
                    : null
            }
            
            {
                status == "Verified" && guiLanguage != 'tr' ?
                    <div className="mail-verification">
                    
                        Your e-mail is verified. You can happily <LoginLink lang='en' /> now! 
                        
                    </div>
                    : null
            }
        </div>
    )
}

function LoginLink(props) {
    return (
        <React.Fragment>
            <a href={'/Login?lang=' + props.lang}>{ props.lang == 'tr' ? 'Giriş' : 'Login'}</a>
        </React.Fragment>
    )
}
